import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { ClarityExpert } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
export const ClarityExpertSEO = props => {
  const $ = _c(7);
  const expert = props.clarityExpert;
  let t0;
  if ($[0] !== expert.bio || $[1] !== expert.fullName || $[2] !== expert.shortBio || $[3] !== expert.topics) {
    const seoProps = {};
    const t1 = expert.fullName;
    let t2;
    if ($[5] !== expert.topics) {
      t2 = expert.topics.map(_temp).splice(0, 3).join(", ");
      $[5] = expert.topics;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    seoProps.title = `${t1} | Startup Expert in ${t2}`;
    seoProps.description = expert.shortBio || expert.bio || seoProps.title;
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = expert.bio;
    $[1] = expert.fullName;
    $[2] = expert.shortBio;
    $[3] = expert.topics;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
ClarityExpertSEO.fragments = {
  ClarityExpert: () => gql`
    fragment _ on ClarityExpert {
      id
      firstName
      lastName
      shortBio
      screenName
      topics {
        id
        name
      }
    }
  `
};
function _temp(t) {
  return t.name;
}